package br.com.texeratx.boardgametimeapp.ui.screens.active_match

import br.com.texeratx.boardgametimeapp.data.model.expansion.ExpansionDTO
import br.com.texeratx.boardgametimeapp.data.model.game.GameDTO
import br.com.texeratx.boardgametimeapp.data.model.player.PlayerDTO

data class StartMatchSetupUiState(
    val isLoading: Boolean = false,
    val error: String? = null,

    val games: List<GameDTO> = emptyList(),
    val players: List<PlayerDTO> = emptyList(),
    val expansions: List<ExpansionDTO> = emptyList(),

    val selectedGameId: Long? = null,
    val selectedPlayerIds: Set<Long> = emptySet(),
    val selectedExpansionIds: Set<Long> = emptySet(),
)
